"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForcedPrecipitation = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const constants_1 = require("../../constants");
const CardName_1 = require("../../CardName");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const LogHelper_1 = require("../../LogHelper");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class ForcedPrecipitation extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.FORCED_PRECIPITATION,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS],
            cost: 8,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: '226',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 2 M€ to add 1 Floater to THIS card.', (eb) => {
                        eb.megacredits(2).startAction.floaters(1).asterix;
                    }).br;
                    b.or().br;
                    b.action('Spend 2 Floaters here to increase Venus 1 step.', (eb) => {
                        eb.floaters(2).startAction.venus(1);
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const trGain = this.getTotalTRGain(player);
        if (this.resourceCount >= 2)
            Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'raise Venus');
        const venusMaxed = player.game.getVenusScaleLevel() === constants_1.MAX_VENUS_SCALE;
        const canSpendResource = this.resourceCount > 1 && !venusMaxed;
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
        }
        if (redsAreRuling && !venusMaxed) {
            return player.canAfford(2) || (canSpendResource && player.canAfford(this.reserveUnits.megacredits));
        }
        return player.canAfford(2) || canSpendResource;
    }
    action(player) {
        const opts = [];
        const addResource = new SelectOption_1.SelectOption('Pay 2 to add 1 floater to this card', 'Pay', () => this.addResource(player));
        const spendResource = new SelectOption_1.SelectOption('Remove 2 floaters to raise Venus 1 step', 'Remove floaters', () => this.spendResource(player));
        const canAffordRed = !PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS) || player.canAfford(this.reserveUnits.megacredits);
        if (this.resourceCount > 1 && player.game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE && canAffordRed) {
            opts.push(spendResource);
        }
        else {
            return this.addResource(player);
        }
        ;
        if (player.canAfford(2)) {
            opts.push(addResource);
        }
        else {
            return this.spendResource(player);
        }
        return new OrOptions_1.OrOptions(...opts);
    }
    addResource(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 2, { title: 'Select how to pay for action' }));
        player.addResourceTo(this, { log: true });
        return undefined;
    }
    spendResource(player) {
        player.removeResourceFrom(this, 2);
        player.game.increaseVenusScaleLevel(player, 1);
        LogHelper_1.LogHelper.logVenusIncrease(player, 1);
        return undefined;
    }
    getTotalTRGain(player) {
        const venusScale = player.game.getVenusScaleLevel();
        let trGain = venusScale === constants_1.MAX_VENUS_SCALE ? 0 : 1;
        if (venusScale === 14)
            trGain += 1;
        return trGain;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ venusIncrease: 1 });
    }
}
exports.ForcedPrecipitation = ForcedPrecipitation;
//# sourceMappingURL=ForcedPrecipitation.js.map